<script lang="ts">
  interface Props {
    isDisabled?: boolean;
    onClick: () => void;
    /** 아이콘 전용 원형 버튼의 접근명(스크린리더). */
    ariaLabel?: string;
    children?: import('svelte').Snippet;
  }

  let { isDisabled = false, onClick, ariaLabel = undefined, children }: Props = $props();
</script>

<button
  disabled={isDisabled}
  onclick={onClick}
  aria-label={ariaLabel}
  title={ariaLabel}
  class="flex h-[56px] w-[56px] cursor-pointer select-none items-center justify-center
   transition-colors rounded-full
   border border-textcolor2 text-gray-300
   hover:border-gray-300 
   {isDisabled ? 'cursor-not-allowed!' : ''}"
>
  {@render children?.()}
</button>
